"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalPopup = ModalPopup;
var _react = _interopRequireWildcard(require("react"));
var _wbmInputs = require("wbm-inputs");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
require("../../../sass/modalDialog.scss");
var _ScrollBarService = _interopRequireDefault(require("./ScrollBarService"));
var _wbmLoader = require("wbm-loader");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ModalPopup(props) {
  var _React$useState = _react["default"].useState(props.setShow || false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(props.isLoading || false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoading = _React$useState4[0],
    setIsLoading = _React$useState4[1];
  var modalOpenApplied = (0, _react.useRef)(open);
  (0, _react.useEffect)(function () {
    if (modalOpenApplied) {
      return function () {
        if (modalOpenApplied.current) {
          if (document.getElementsByClassName("main-slide-in-box").length <= 0) {
            console.log("removing modal-open at unmount");
            _ScrollBarService["default"].applyModalOpen(false);
          } else {
            console.log("keeping modal-open as slidein is open");
            _ScrollBarService["default"].keepModalOpen(true);
          }
        }
      };
    } else {
      return;
    }
  }, [modalOpenApplied]);
  (0, _react.useEffect)(function () {
    if (props.setShow !== undefined) {
      setOpen(props.setShow);
    }
  }, [props.setShow]);
  (0, _react.useEffect)(function () {
    if (props.isLoading !== undefined) {
      setIsLoading(props.isLoading);
    }
  }, [props.isLoading]);
  var handleClickOpen = function handleClickOpen() {
    setOpen(true);
  };
  var handleClose = function handleClose() {
    setOpen(false);
    if (props.onClose) {
      props.onClose();
    }
  };
  var handleBackdropClick = function handleBackdropClick() {
    if (!props.disableBackdropClick) {
      handleClose();
    }
  };
  var handleActionItem = function handleActionItem(event) {
    setOpen(false);
    if (props.actionItem) {
      props.actionItem(event);
    }
  };
  var modalClass = "modal-parent";
  if (props.className) {
    modalClass += " " + props.className;
  }
  (0, _react.useEffect)(function () {
    if (open === true) {
      _ScrollBarService["default"].applyModalOpen(true);
      modalOpenApplied.current = true;
    } else if (open === false) {
      if (document.getElementsByClassName("main-slide-in-box").length <= 0) {
        _ScrollBarService["default"].applyModalOpen(false);
      } else {
        console.log("keeping modal-open as slidein is open");
        _ScrollBarService["default"].keepModalOpen(true);
      }
      modalOpenApplied.current = false;
    }
  }, [open]);
  var zIndex = 1300;
  if (props.customZIndex) {
    zIndex = props.customZIndex;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-popup"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sis-button",
    onClick: handleClickOpen
  }, props.button), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    onClose: handleBackdropClick,
    "aria-labelledby": "simple-dialog-title",
    open: !!open,
    hideBackdrop: true,
    className: modalClass,
    PaperProps: {
      style: {
        boxShadow: props.boxShadow ? "0px 3px 6px #00000029" : "none",
        border: "1px solid #D9D9DA",
        pointerEvents: isLoading ? "none" : "auto"
      }
    },
    maxWidth: props.maxWidth,
    disableScrollLock: true,
    style: {
      zIndex: zIndex
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "header font-weight-bold"
  }, props.header, " ", props.closeIcon ? /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    onClick: handleClose,
    className: "close-icon"
  }) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content"
  }, isLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react["default"].createElement(_wbmLoader.WBMLoader, null)), props.children), props.actionItem ? /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
    className: "action-section"
  }, props.showCancelButton && /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    onClick: handleClose,
    className: "btn-link"
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    onClick: handleActionItem,
    className: props.dangerButton ? "btn-primary danger" : "btn-primary"
  }, props.actionItemText)) : null));
}
//# sourceMappingURL=modalPopup.js.map